import Axios from "axios";
import type {
  VisitorConsentDocument,
  VisitorConsentDocumentUpsertDraft
} from "../../../features/VisitorConsent/visitor-consent-documents.context";

export type VisitorConsentDocumentDto = VisitorConsentDocument;

export const buildVisitorConsentDocumentFormData = (
  draft: VisitorConsentDocumentUpsertDraft
): FormData => {
  const formData = new FormData();
  formData.append("title", draft.title.trim());
  formData.append("description", draft.description.trim());
  formData.append("body", draft.body.trim());
  formData.append("order", String(draft.order));

  if (draft.file) {
    formData.append("file", draft.file);
  }

  if (draft.dropExistingAttachment === true) {
    formData.append("dropExistingAttachment", "true");
  }

  return formData;
};

export const fetchVisitorConsentDocuments = () =>
  Axios.get<VisitorConsentDocumentDto[]>("/visit/consent-documents");

export const createVisitorConsentDocument = (draft: VisitorConsentDocumentUpsertDraft) =>
  Axios.post<VisitorConsentDocumentDto>(
    "/visit/consent-documents",
    buildVisitorConsentDocumentFormData(draft)
  );

export const updateVisitorConsentDocument = (
  documentId: string,
  draft: VisitorConsentDocumentUpsertDraft
) =>
  Axios.patch<VisitorConsentDocumentDto>(
    `/visit/consent-documents/${encodeURIComponent(documentId)}`,
    buildVisitorConsentDocumentFormData(draft)
  );

export const deleteVisitorConsentDocument = (documentId: string) =>
  Axios.delete(`/visit/consent-documents/${encodeURIComponent(documentId)}`);
